// Thin axios wrapper for Radio Clock Builder backend routes.
import axios from 'axios';
import { getBackendUrl } from '../../utils/api';
import storage from '../../utils/storage';

function auth() {
  const token = storage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function base() {
  return `${getBackendUrl()}/api/radio-clock`;
}

export async function listTemplates() {
  const r = await axios.get(`${base()}/templates`, { headers: auth() });
  return r.data;
}

export async function getTemplate(id) {
  const r = await axios.get(`${base()}/templates/${id}`, { headers: auth() });
  return r.data;
}

export async function createTemplate(name, data) {
  const r = await axios.post(`${base()}/templates`, { name, data }, { headers: auth() });
  return r.data;
}

export async function updateTemplate(id, name, data) {
  const r = await axios.put(`${base()}/templates/${id}`, { name, data }, { headers: auth() });
  return r.data;
}

export async function deleteTemplate(id) {
  const r = await axios.delete(`${base()}/templates/${id}`, { headers: auth() });
  return r.data;
}
